import React, { useMemo, useRef, useState } from 'react';

import { Help, Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, TextField } from '@mui/material';
import { get, set } from 'lodash';
import { MUIFieldProps } from '../../../../../lib/types/types';
import MUIToolTip from '../../../mui-tooltip/MUIToolTip';

export const REGEX_LETTERS_ONLY = /[^A-Za-zÄäÖöÜüß '-]+/g;

const MUITextField: React.FC<MUIFieldProps> = (props) => {
	const { type, label, tooltip, fieldValue, updateFieldValue, isDisabled, error, errorMessage, allowLettersOnly, ...restProps } = props;

	const [showPassword, setShowPassword] = useState(false);
	const [inputValue, setInputValue] = useState(fieldValue);

	useMemo(() => {
		setInputValue(fieldValue);
	}, [fieldValue]);

	const timeoutRef: { current: NodeJS.Timeout | null } = useRef(null);

	const debouncedOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		// Clear timeout if there was one pending
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		let inputValue = e.target.value ? e.target.value : '';
		let strapiValue = inputValue;

		if (allowLettersOnly) {
			strapiValue = inputValue.replace(REGEX_LETTERS_ONLY, '');
		} else if (get(props, 'maxDigit')) {
			strapiValue = strapiValue.slice(0, get(props, 'maxDigit'));
		}

		set(e, 'target.value', strapiValue);
		setInputValue(strapiValue);

		// Schedule `onChange` call and store timeout id in the ref
		timeoutRef.current = setTimeout(() => {
			updateFieldValue(e);
		}, 10);
	};

	return (
		<TextField
			fullWidth
			id='demo-helper-text-aligned-no-helper'
			type={showPassword ? 'text' : type}
			label={
				tooltip ?
					<>
						<>{label}</>
						<MUIToolTip title={tooltip}>
							{' '}
							<Help fontSize='small' color='primary' sx={{ ml: '5px' }} />{' '}
						</MUIToolTip>
					</>
				:	<>{label}</>
			}
			value={inputValue}
			onChange={debouncedOnChange}
			disabled={isDisabled}
			error={error}
			helperText={errorMessage}
			InputProps={{
				endAdornment: type === 'password' && (
					<IconButton
						aria-label={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
						aria-pressed={showPassword}
						onClick={() => setShowPassword(!showPassword)}
					>
						{showPassword ?
							<Visibility />
						:	<VisibilityOff />}
					</IconButton>
				),
			}}
			{...restProps}
		/>
	);
};

export default MUITextField;
